import type { DeepString } from "@/lib/i18n";

/**
 * WContactForm — polskie tłumaczenia.
 *
 * Fallback gdy backend `content.lang.*` nie dostarczy stringa + komunikaty
 * walidacyjne (zod) + statusy systemowe (rate limit, anti-spam delay, sieć).
 */
export const pl = {
  /** Brak danych konfiguracji okna. */
  noConfig: "Brak danych konfiguracji formularza.",
  /** Tryb CRM bez aktywnego modułu. */
  crmModeWithoutModule: {
    body1: "Formularz jest skonfigurowany w trybie wysyłki do CRM, ale moduł",
    moduleName: "m_crm_sales_support",
    body2:
      'nie jest aktywny w tej domenie. Włącz moduł w panelu administracyjnym lub zmień tryb wysyłki na "email" w konfiguracji okna.',
  },
  /** Nieznany tryb wysyłki. */
  unknownSendMode: (mode: string) =>
    `Nieznany tryb wysyłki w konfiguracji formularza: ${mode}.`,

  /* ─── Backend fallback labels ─── */
  labels: {
    text: "Treść",
  },
  send: "Wyślij",
  sending: "Wysyłanie…",

  /* ─── Walidacja (zod messages) ─── */
  validation: {
    requiredField: (label: string) => `Pole "${label}" jest wymagane.`,
    invalidEmail: "Niepoprawny adres email.",
    requiredText: 'Pole "Treść" jest wymagane.',
    requiredPersonalData: "Wymagana zgoda na przetwarzanie danych osobowych.",
  },

  /* ─── Statusy submitu / errory systemowe ─── */
  status: {
    waitBeforeSubmit: (seconds: number) =>
      `Poczekaj jeszcze ${seconds} sekund przed wysłaniem.`,
    rateLimit: "Zbyt wiele prób z tego adresu IP. Spróbuj za chwilę.",
    sendFailed: "Nie udało się wysłać wiadomości.",
    sendSuccess: "Wiadomość została wysłana, dziękujemy!",
    networkError: (message: string) => `Błąd sieci: ${message}`,
    networkErrorGeneric: "Błąd sieci podczas wysyłania.",
  },
} as const;

export type WContactFormTranslations = DeepString<typeof pl>;
